import { ArrivalVM, DepartureVM } from "./ArrivalDepartureModel";
import { TranslatorThingy } from "./TranslatorThingy";

export const INIT_DATA: Booking = {

  totalPrice: null,
  totalDiscountPrice: null,
  discountAmount: null,
  discountPercent: null,

  order: {
    organizationId: '',
    bundleCode: '',
    productCode: '',
    discountCode: '',
    comment: ''
  },
  customer: {
    firstname: '',
    lastname: '',
    email: '',
    cellular: ''
  },
  parking: {
    parkingId: '',
    productCode: '',
    carId: '',
    parkingFrom: '',
    parkingTo: '',
    comment: '',
    extendPeriod: null
  },
  shuttles: [
    {
      stationcode: '',
      shuttletypecode: '',
      productcode: '',
      shuttledate: '',
      flightnr: '',
      flightterminal: '',
      terminal: '',
      passengers: '',
      childseats: '',
      baggage: '',
      comment: ''
    },
    {
      stationcode: '',
      shuttletypecode: '',
      productcode: '',
      shuttledate: '',
      flightnr: '',
      flightterminal: '',
      terminal: '',
      passengers: '',
      childseats: '',
      baggage: '',
      comment: ''
    }
  ]
};

export interface Booking {
  totalPrice?: number;
  totalDiscountPrice?: number;
  discountAmount?: number;
  discountPercent?: number;
  order: OrderType;
  customer: Customer;
  parking: Parking;
  shuttles?: Shuttle[];
  additionalServices?: any[];
  externalBookingReference?: string;
  isFromCustomerHome?: boolean;
}

export interface EditOrderParking {
  orderParkingId: string;
  carId: string;
  parkingFrom: string;
  parkingFromTime: string;
  parkingTo: string;
  parkingToTime: string;
  checkIn?: Date;
  checkInTime: string;
  checkOut?: Date;
  checkOutTime: string;
  comment: string;
  parkingSiteId: string;
}

export interface EditOrderShuttle {
  orderShuttleId: string;
  status: number;
  orderShuttleBusId: string;
  departureId: string;
  arrivalId: string;
  flightNr: string;
  terminal: string;
  passengers: number;
  childSeats: number;
  baggage: number;
  comment: string;
  shuttleDate: string;
  shuttleDateTime?: string;
}

export interface EditOrderShuttleBus {
  orderShuttleBusId: string;
  busId: string;
  startDate: string;
}

export interface MatTableOrder {
  amountDiscount: any;
  code: any;
  comment: string;
  customer: OrderCustomer;
  discountAmount: any;
  discountPercent: any;
  externalBookingReference?: any;
  invoiceNr: any;
  invoiceOcr: any;
  orderDate: Date;
  orderId: string;
  orderNr: number;
  organizationId?: any;
  paymentDate?: any;
  paymentReference?: string;
  paymentStatus?: any;
  productName?: any;
  status: string;
  totalPriceExVat: number;
  totalPriceIncVat: number;
  totalVat?: number;
}

export interface MyOrder extends Order {
  customerName: string;
  cellular: string;
  email: string;
}

export interface OrderPaginationModel {
  OrderNos?: number[],
  TransactionNos?: number[],
  OrderIds?: string[],
  CommonSearch?: string,
  Created?: dateRange,
  BookingBegin?: dateRange,
  BookingEnd?: dateRange,
  Status?: number | '',
  SortingColumn?: string,
  SortingDirection?: string,
  Paginate?: {
    PerPage: number,
    Page: number
  },
  OrderNrSearch?: string,
  TransactionNrSearch?: string,
  NameSearch?: string,
  EmailSearch?: string,
  PhoneSearch?: string,
  LPSearch?: string,
  Statuses?: number[],
  OrganizationIds?: string[],
  OrderTypes?: string[],
  DebtStage?: number
}

export interface DebtReminders {
  additionalPaymentSent?: string;
  debtReminder1Sent?: string;
  debtReminder2Sent?: string;
  debtReminder3Sent?: string;
}

export interface DebtOrder extends Order {
  debtAmount: number;
  additionalPaymentSent?: string;
  debtReminder1Sent?: string;
  debtReminder2Sent?: string;
  debtReminder3Sent?: string;
}

export interface AdditionalServicePaginationModel {
  FromUtc: {
    From: string,
    To: string
  },
  ToUtc: {
    From: string,
    To: string
  },
  Planned: {
    From: string,
    To: string
  },
  OrderIds: string[],
  AdditionalServiceIds: string[],
  AdditionalServiceType: number,
  PerformingOrgIds: string[],
  ParkingIds: string[],
  Statuses: number[],
  LPSearch: string,
  SortingColumn: string,
  SortingDirection: string,
  Paginate: {
    PerPage: number,
    Page: number
  }
}

export interface dateRange {
  From: string,
  To: string
}

export interface PaymentId {
  id: string;
  paymentType: string;
}

export interface PaymentReference {
  operations: Operations;
  payment: Payment;
}

export interface Operations {
  contentType: string;
  href: string;
  method: string;
  rel: string;
}

export interface Payment {
  amount: string;
  authorizations: any;
  cancellations: any;
  captures: any;
  created: string;
  currency: string;
  description: string;
  id: string;
  initiatingSystemUserAgent: any;
  instrument: string;
  intent: string;
  language: string;
  number: string;
  operation: string;
  payeeInfo: PayeeInfo;
  payerReference: any;
  prices: Prices;
  remainingCancellationAmount: any;
  remainingCaptureAmount: any;
  remainingReversalAmount: any;
  reversals: any;
  settings: any;
  state: string;
  transactions: null;
  updated: string;
  urls: Urls;
  userAgent: string;
}

export interface PayeeInfo {
  id: string;
}

export interface Prices {
  id: string;
}

export interface Urls {
  id: string;
}

export interface AvailableParkings {
  organizationId: string;
  discountCode: string;
  parkings: AvailableParking[];
}

export interface AvailableParking {
  id: string;
  name: string;
  description: string;
  bundleCode: string;
  bundleId: string;
  productId: string;
  productCode: string;
  availableParkingSpots: number;
  price: number;
  vat: number;
  vatPercentage: number;
  totalPrice: number;
  discountAmount: number;
  discountVatAmount: number;
  discountTotalPrice: number;
  discountCheckPercent: number;
  discountCheckAmount: number;
}

export interface OrderExternal {
  status: string;
  departureDate: string;
  departureTime: string;
  departureFlightNr: string;
  arrivalDate: string;
  arrivalTime: string;
  arrivalFlightNr: string;
  externalBookingNr: string;
  customerName: string;
  passengers: number;
  cars: number;
}

export interface ExternalOrders {
  company: string;
  externalOrders: OrderExternal[];
}

export interface Order {
  debtReminders?: DebtReminders;
  amountDiscount: any;
  vatAmountDiscount: any;
  code: any;
  comment: string;
  customer: OrderCustomer;
  customerName?: string;
  cellular?: string;
  email?: string;
  discountAmount: any;
  discountPercent: any;
  externalBookingReference?: any;
  externalId?: any;
  invoiceNr: any;
  invoiceOcr: any;
  orderDate: Date;
  orderId: string;
  orderNr: number;
  organizationId?: any;
  organizationName?: any;
  paymentDate?: any;
  paymentType: string;
  paymentReference?: string;
  paymentStatus?: any;
  productName?: any;
  status: string;
  totalPriceExVat: number;
  totalPriceIncVat: number;
  totalVat?: number;
  totalDiscountPriceIncVat?: number;
  carId: string;
  hasDevice: boolean;
}

export interface OrderLog {
  orderLogId: string;
  orderId: string;
  description: string;
  created: Date;
  createdBy: string;
  log: string;
}

export interface PaginatedOrderLogs {
  data: OrderLog[];
  total: number;
}

export interface TransactionRowVM {
  transactionRowId: string;
  transactionId: string;
  orderBundleId: string;
  orderRowId: string;
  amount: number;
  vatAmount: number;
  vat: number;
  created: Date;
  createdBy: string;
  productName: string;
  status: string;
}

export interface TransactionVM {
  transactionId: string;
  orderId: string;
  transactionNr: number;
  amount: number;
  vatAmount: number;
  amountIncVat: number;
  paymentStatus: string;
  paymentType: string;
  paymentDate: Date;
  paymentReference: string;
  debitCreditType: string;
  created: Date;
  createdBy: string;
  transactionRowVMs: TransactionRowVM[];
  remainingReversalAmount: number;
  payeeReference?: string;
}

export interface TransactionPaginatedModel {
  OrderNrSearch?: string;
  OrganizationIds?: string[];
  TransactionNrSearch?: string;
  Created?: dateRange;
  PaymentStatuses?: string[];
  PaymentType?: string;
  Paginate?: {
    PerPage: number,
    Page: number
  };
}

export interface OrderCustomer {
  cellular?: string;
  created?: any;
  customerId?: string;
  email: string;
  externalId: any;
  firstName: string;
  lastName: string;
  userId: string;
}

export interface OrderType {
  organizationId: string;
  bundleCode: string;
  productCode: string;
  discountCode: string;
  comment: string;
  externalBookingReference?: string;
  shuttleOrganizationId?: string;
  isFromCustomerHome?: boolean;
}

export interface Customer {
  customerId?: string;
  firstname: string;
  lastname: string;
  email: string;
  cellular: string;
}

export interface Parking {
  parkingId: string;
  productCode: string;
  carId: string;
  parkingFrom: string;
  parkingTo: string;
  comment: string;
  extendPeriod: number;
  passengers?: number;
  parkingCapacityMultiplier?: string | null; // encoded on backend, pass through as is
}

export interface OrderHotel {
  orderHotelId: string;
  orderId: string;
  orderRowId: string;
  hotelId: string;
  Status: string;
  hotelFrom: Date;
  hotelTo: Date;
  nrOfPersons: number;
  nrOfNights: number;
  comment: string;
}

export interface Shuttle {
  stationcode?: string;
  productcode?: string;
  carid?: string;
  parkingfrom?: string;
  parkingto?: string;
  comment?: string;
  extendPeriod?: number;
  shuttletypecode?: string;
  shuttledate?: string;
  flightnr?: string;
  flightdate?: string;
  flightdeparturedate?: string;
  flightterminal?: string;
  terminal?: string;
  passengers?: string;
  childseats?: any;
  baggage?: any;
  ordershuttlebusid?: string;
}

export interface ParkingOrder {
  carId: string;
  cellular: string;
  checkIn: any;
  checkInUserId: string;
  checkOut: any;
  comment: string;
  email: string;
  firstName: string;
  lastName: string;
  parkingFrom: string;
  parkingSiteName: string;
  parkingTo: string;
  status: string;
}

export interface OrderShuttleBundleVM {
  orderShuttleId: string;
  orderId: string;
  orderRowId: string;
  shuttleTypeId: string;
  flightNr: string;
  status: string;
  passengers: number;
  childSeats: number;
  baggage: number;
  comment: string;
  shuttleTypeName: string;
  shuttleTypeCode: string;
  shuttleDate?: Date;
  terminal: String;
}


export interface OrderShuttleVM {
  orderShuttleId: string;
  orderId: string;
  orderNr: string;
  customerId: string;
  orderShuttleBusId: string;
  firstName: string;
  lastName: string;
  cellular: string;
  email: string;
  shuttleTypeName: string;
  shuttleTypeCode: string;
  flightNr: string;
  status: string;
  passengers?: number;
  childSeats?: number;
  baggage?: number;
  comment: string;
  orderDate?: Date;
  shuttleDate?: string;
  shuttleUpdated?: Date;
  shuttleDateNew?: Date;
  isReadyForPickup?: boolean;
  productType: string;
  terminal: string;
  routeName: string;
  routeCode: string;
  busStartDate?: Date;
  busStatus: string;
  departureId: string;
  departureVM?: DepartureVM;
  arrivalId: string;
  arrivalVM?: ArrivalVM;
  orderParkingParkingSiteName: string;
  carId: string;
  extra: OrderShuttleExtra;
  orderExtra: OrderExtra;
  keyStatus: string;
  orderLockerId: string;
  passengerLandedOrBooked?: Date | string;
  orderParkingCarId: string;
  orderSafe: string;
  organizationId: string;
  ReadyForPickup: boolean;
  problemFlight?: { arrival: boolean; departure: boolean };
  hasDevice: boolean;
}

export interface OrderExtra {
  mobileAppUserData: string;
}

export interface OrderShuttleExtra {
  pressedButtonInApp: string;
}


export interface OrderParkingVM {
  orderParkingId: string;
  orderId: string;
  customerId: string;
  orderRowId: string;
  parkingSiteId: string;
  productId: string;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  zip: string;
  cellular: string;
  email: string;
  parkingSiteName: string;
  productName: string;
  carId: string;
  status: string;
  comment: string;
  parkingFrom: string;
  parkingTo: string;
  checkIn?: Date;
  checkOut?: Date;
  checkInUserId?: any;
  temporaryParking?: Date;
  created: Date;
  orderNr?: number;
  parkingId: string;
  parking?: string;
  organizationId?: string;
  organizationName?: string;
  organizationParentId?: string;
  parkingProductType?: string;
  passengers?: number;
}


export interface OrderBundleRow {
  orderRowId: string;
  bundleRowId: string;
  bundleId: string;
  productId: string;
  bundleRowName: string;
  bundleRowDescription: string;
  active: boolean;
  productName: string;
  productDescription: string;
  orderShuttleVM?: OrderShuttleVM;
  orderParkingVM?: OrderParkingVM;
}

export interface OrderBundle {
  orderBundleId: string;
  orderId: string;
  bundleId: string;
  amount: number;
  vatAmount: number;
  discountAmount?: any;
  discountPercent?: any;
  vat: number;
  name: string;
  code: string;
  description: string;
  orderBundleRows: OrderBundleRow[];
}

export interface Status {
  value: string;
  viewValue: string;
}

export interface OrderRow {
  orderParkings: OrderParkingVM[];
  orderShuttles: OrderShuttleVM[];
}

export interface OrganizationParkingsVM {
  parkingsPaidNoArrived: OrderParkingVM[];
  parkingsForCheckOut: OrderParkingVM[];
}

export interface OrganizationDiscountCheckVM {
  id: string;
  parkingId: string;
  parkingName: string; bundleId: string;
  bundleName: string;
  discountCode: string;
  discountPercent: string;
  discountAmount: string;
  discountType?: number;
  discountTypeName?: string | any[];
  validFrom: Date;
  validTo: Date;
  created: Date;
  status: string;
  // Parkings whose discount quotas use this code; its validity period can't be changed while non-empty
  quotaParkingNames?: string[];
}

export interface EditOrganizationDiscountCheckRequest {
  id: string;
  parkingId: string;
  discountCode: string;
  discountPercent: string;
  discountAmount: string;
  validFrom: Date;
  validTo: Date;
  discountType?: number;
}

export interface OrganizationAdditionalServiceVM {
  id: string;
  name: string;
  description: string;
  servicesPerDay?: number; // number of services per day
  productId: string;
  productCode: string;
  availability: number;
  minimumStay: number;
  statusName: string;
  typeName: string;
  price: number;
  vat: number;
  vatPercentage: number;
  totalPrice: number;
  discountAmount: number;
  discountVatAmount: number;
  discountTotalPrice: number;
  discountCheckPercent: number;
  discountCheckAmount: number;
  performingOrganizationId: string;
  performingOrganizationName: string;
}

export interface EditOrganizationAdditionalServiceRequest {
  id?: string,
  name: TranslatorThingy,
  description: TranslatorThingy,
  productId?: string,
  productCode: string,
  availability: number,
  minimumStay?: number,
  status: number,
  price: number,
  isMandatory: boolean,
  performingOrganizationId?: string
}

export interface OrganizationParkingPricingVM {
  id: string;
  name: string;
  code: string;
  description: string;
  noOfDays?: number;
  price: number;
  vat: number;
  active: boolean;
  totalPrice?: number;
  discountAmount?: number;
  discountPercent?: number;

  productType?: number;
  productTypeName?: string;
  orderRows?: any;
  organization?: any;
  organizationId?: string;
  parking?: any;
  parkingId?: string;

  created?: string;
  createdByUserId?: string;
  updated?: string;
  updatedByUserId?: string;
}

export interface EditOrganizationParkingPricingRequest {
  id?: string;
  name: string;
  code: string;
  description: string;
  price: number;
  vat: number;
  active?: boolean;
}

export interface EditOrderAdditionalServiceRequest {
  id: string;
  status: number;
  planned?: Date | String;
}

export interface KeyTaskVM {
  lockerId: string,
  locker: string,
  orderId: string,
  order: string,
  type: number,
  userId: string,
  user?: {
    id: string,
    email: string,
  },
  status: number,
  statusName?: string,
  created: string,
  updated: string,
  safeHook?: string,
  orderSafe?: {
    hookId: string,
    hook: SafeHook,
    hookNo: string,
    hookSafeName: string,
    orderId: string,
    order: string,
    status: number,
    updated: string,
    createdByUserId: string,
    updatedByUserId: string,
    created: string,
    id: string
  },
  connectedUserId?: string,
  connectedUserEmail?: string, //shown
  updatedByUserId?: string,
  id: string
}

export interface AirTagVM {
  organizationId: string,
  name: string,
  description: string,
  status: number,
  createdByUserId: string,
  updatedByUserId: string,
  created: string,
  updated: string,
  orderId?: string,
  orderAdditionServiceId?: string,
  id: string
}

export interface SafeHook {
  hookNo: number,
  safeName: string,
  status: number,
  updated: string,
  createdByUserId: string,
  updatedByUserId: string,
  created: string,
  id: string
}

export interface VehicleDetailsVM {
  type: string,
  attributes: {
    regno: string, //shown
    vin: string
  },
  basic: {
    data: {
      make: string, //shown
      model: string, //shown
      status: string, //shown
      color: string, //shown

      type: string, //shown
      type_high: string,
      type_class: string,

      vehicle_year: number, //shown
      model_year: number, //shown
      reused_regno: boolean,
      inspection_valid_until: string | null,
    }
  },
  owner: {
    data: {
      type: string, // person | org //shown
      parsedPerson: {
        pnr: number,
        status: string,
        sex: string,
        birth_year: number,
        name: {
          given_name: string,
          first_name: string,
          middle_name: string,
          last_name: string,
          full_name: string, //shown
        },
        address: {
          co: string, // shown ( care of )
          name: string,  //shown
          zip_code: string, //shown
          city: string,//shown
          municipality: string, //shown
          county: string,//shown
          municipality_code: string, //shown
          county_code: string //shown
        },
        phone: [] //shown
      },
      parsedCompany: {
        orgnr: string,
        ts_branch_number: string,
        ts_branch_name: string,
        status: string,
        status_detailed: string,
        legal_group: string,
        name: {
          legal_name: string //shown
        },
        address: { //show
          co: string,
          name: string,
          zip_code: string,
          city: string,
          municipality: string,
          county: string,
          municipality_code: string,
          county_code: string
        },
        phone: string[],
        sni: {
          code_1: string,
          code_2: string,
          code_3: string,
          code_4: string,
          code_5: string
        },
        purchase_status: number,
        purchase_date: string
      }
    }
  },
  cashedAt: string // shown
}

export interface OrganizationGatesVM {
  id: string,
  externalId: string,
  name: string,
  description: string,
  parkingIds: string[],
  allowDriveUp: boolean
}

export interface OrganizationVehiclesVM {
  organizationId: string;
  vehicleId: string;
  regNo: string;
  comment: string;
  gates: string[];
}

export interface OrganizationVehicleEdit {
  organizationId: string;
  vehicleId?: string;
  regNo: string;
  comment: string;
  gates: string[];
}

export enum GateMode {
  AUTO = "AUTO",
  FREE = "FREE",
  BLQP = "BLQP",
  BLCL = "BLCL"
}

export interface ParkingSession {
  licensePlate: string,
  parkingId: string,
  parkingName?: string,
  inTime: string,
  comment: string,
  created?: string,
  createdByUserId?: string,
  id?: string,
  images?: any[],
  orderId?: string,
  outTime?: string,
  updated?: string,
  updatedByUserId?: string
}

export interface LPRLogsRequestModel {
  sensorIds: string[],
  lisencePlate: string,
  createdAt: dateRange,
  SortingColumn?: string,
  SortingDirection?: 'asc' | 'desc',
  Paginate?: {
    PerPage: number,
    Page: number
  },
  actions?: string[]
}

export interface LPRLogVM {
  id: string;
  created: string;
  definedData: {
    datetime: string;
    plateText: string;
    cameraSerialNumber: string;
    cameraIPAddress: string;
    sensorProviderID: string;
  }
  images?: string[];
  action?: string;
  direction?: string;
}

export interface VehicleLiveStatus {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  groundSpeed: number;
  heading: number;
  ignitionOn: boolean;
  driverName: string | null;
}
